const swiperEl = {
    id: '',
    carouselParent: 'card-carousel-parent-js',
    swiperContainer: 'swiper-cards-carousel',
    swiperCarousel: 'swiper-wrapper',
    swiperSlide: 'swiper-slide',
    categoryTag: 'card-carousel-tag-js',
    carouselCard: 'card-carousel-js',
    cardDoubleSided: 'js-card-double-sided',
    cardDoubleSidedBottom: 'js-card-double-sided-bottom'
}

const handleCategoryTags = function(relevantTag, allTags){
    if(allTags) {
        allTags.forEach(tag => tag.classList.remove('button--tertiary--active'))
    }

    relevantTag.classList.add('button--tertiary--active');

    return relevantTag.getAttribute('data-type');
}

const toggleCategories = function(carouselCards, relevantTag, allTags, carouselParent){

    const relevantTagAttr = handleCategoryTags(relevantTag, allTags)

    const carouselCardsArr = [...carouselCards];

    carouselCardsArr.filter(carCard => carCard.getAttribute('data-type') !== relevantTagAttr).forEach(wrongCard => wrongCard.style.display = 'none');

    carouselCardsArr.filter(carCard => carCard.getAttribute('data-type') === relevantTagAttr).forEach(filteredCard => filteredCard.style.display = 'flex')

    if (carouselParent) {
        const swiperCustomEl = carouselParent.querySelector('swiper-component');
        if (swiperCustomEl) {
            swiperCustomEl.swiper.update();
            swiperCustomEl.querySelector('.swiper-wrapper').style.transform = "translate3D(0,0,0)";
        }
    }
}

const handleSidesSwitching = function(bottomSide){
    if (bottomSide.hasAttribute('flipped')) {
        bottomSide.removeAttribute('flipped')
        return;
    }

    if (!bottomSide.hasAttribute('flipped')) {
        bottomSide.setAttribute('flipped', '')
        return;
    }
}

export default function(carouselParent){

    swiperEl.id = carouselParent.getAttribute('data-section-id');

    const allCarouselCards = carouselParent.querySelectorAll('.' + swiperEl.carouselCard);
    const allCategoryTags = carouselParent.querySelectorAll('.' + swiperEl.categoryTag);

    if(allCategoryTags.length >= 1) toggleCategories(allCarouselCards, allCategoryTags[0]);

    allCategoryTags.forEach(tag => tag.addEventListener('click', e => toggleCategories(allCarouselCards, e.target, allCategoryTags, carouselParent)))

    const doubleSidedCards = carouselParent.querySelectorAll('.' + swiperEl.cardDoubleSided);
    if (doubleSidedCards.length > 0) {
        doubleSidedCards.forEach(card => card.addEventListener('click', e => {
            handleSidesSwitching(e.target.closest('.' + swiperEl.cardDoubleSided).querySelector('.' + swiperEl.cardDoubleSidedBottom))
        }))
    }
}
